const SomethingWentWrong =()=>{
    console.log({URL:window.location.href})
    window.location.href = '/#/admin/errorPage/true';
}

const controller = new AbortController();
const signal = controller.signal;

export {SomethingWentWrong, controller, signal}